<script lang='ts'>
  import Chevron from "~/icons/Chevron.svelte";
  import ActionButton from "../ActionButton.svelte";

  const { open }: { open: boolean } = $props();

</script>

<div class=expand-button class:expanded={open}>
  <ActionButton>
    <Chevron />
  </ActionButton>
</div>

<style lang='scss'>
  .expand-button {
    width: 3rem;
    z-index: 2;
    :global(.action) {
      width: 44px;
      height: 44px;
      align-items: center;
      justify-content: center;
      transition: transform 0.25s ease;
      padding: 8px;
    }
  }
  .expanded :global(.action) {
    transform: rotate(180deg);
  }
</style>